import { useTranslation } from 'react-i18next';

import { Can } from 'components/Can';
import ProgramProposalViewList from 'features/ProgramProposal';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function ProgramProposalViewListPage() {
  const { t } = useTranslation();
  return (
    <LayoutProvider>
      <Layout>
        <>
          <Can do="read" on="program">
            <ProgramProposalViewList />
          </Can>
          <Can not do="read" on="program">
            <h4 className="text-red-500">{t('permission.forbid.read.programList')}</h4>
          </Can>
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default ProgramProposalViewListPage;
